export const HOME_PAGE = '/';

export const API = "/api"
export const DISCLAIMER_FROM_HOME = "/disclaimer"
export const PRIVACY_POLICY_PAGE = "/privacy-policy"
export const TERMS_PAGE = "/terms-and-conditions"
export const NOT_FOUND='/404'

export const CONTACT_US = "/contact-us"
